module.exports = __webpack_public_path__ + "static/img/solutions-7.0137d50.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/solutions-7.jpeg
// module id = F+5P
// module chunks = 1